import {useEffect} from 'react'
import {store} from '../utilities'
import {activate, category} from '../action_creators'
import FormArchives from '../../DAL/FormArchives'
import { collection, onSnapshot } from 'firebase/firestore'

export default function useGetFields(archiveId, sections) {
  console.log('useGetFields 0', archiveId, sections)
  useEffect(function () {
    const state = store.getState()
    console.log('useGetFields', archiveId, sections)
    if (!archiveId || !state.active.section) return

    console.log('sections', sections)

    const formArchives = new FormArchives()
    const archiveRef = formArchives.docRef(archiveId)
    const unsubscribes = []

    for (let sectionId in sections) {
      const fieldsRef = collection(archiveRef, 'sections', sectionId, 'fields')

      const unsubscribe = onSnapshot(fieldsRef, (snapshot) => {
        const ff = {}
        snapshot.docs.forEach((doc) => {
          ff[doc.id] = {id: doc.id, ...doc.data()}
        })
        store.dispatch(category('fields')(ff))

        const section = state.sections[state.active.section]
        if (sectionId === state.active.section && section.order && !state.active.field)
          store.dispatch(activate('field', section.order[0]))
      })
      unsubscribes.push(unsubscribe)
    }

    return () => {
      unsubscribes.forEach((unsubscribe) => {
        unsubscribe()
      })
    }
  }, [archiveId, sections])
}
